// extracted by mini-css-extract-plugin
export default {"root":"mpGAE99PeH6zN_VZW87D","title":"HWYSUD7v7bJC9NwOfJNh","label":"T05RoEplVnBkgQCia4Tl","private":"lqBvegBN9Fl72lgXe3WI"};